import React from 'react'

const InvoiceView = () => {
  return (
    <div>
      Invoice view page
    </div>
  )
}

export default InvoiceView